// extracted by mini-css-extract-plugin
module.exports = {"error-code":"CustomComponent_error-code__22Gz0","custom-component":"CustomComponent_custom-component__Tcqy6"};